<template>
<transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <div class="title-header">
              IMPORTANT INFORMATION. PLEASE READ THIS ENTIRE SECTION CAREFULLY
            </div>
            <a class="btn btn-link pull-right close-modal" @click="$emit('close', false)"><i class="fa fa-close"></i></a>
          </div>
          <div class="modal-body terms-and-conditions">
            <div v-html="htmlTac"></div>
          </div>
          <div class="modal-complement">
            <div class="agree-section">
              <div class="form-group materialized check-label">
                <el-checkbox v-model="agreeTAC"> <p>I have read and agree to the terms &amp; conditions as stated above.</p>
                </el-checkbox>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="materialized">
              <button class="btn btn-default" v-on:click="$emit('close', false)">Cancel</button>
              <button :class="{ 'disabled' : !agreeTAC, 'btn btn-primary' : true }" :disabled="!agreeTAC" v-on:click="updatePaymentMethod()">
                <i class="fa fa-cog fa-spin fa-3x fa-fw margin-bottom saving-icon"
                   v-show="isSavingData"></i>Authorize Auto-Billing
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
  import { ServiceContainer } from 'CommonBilling'
  const paymentUpdateService = ServiceContainer.paymentUpdateService

  export default {
    name: 'msomodal',
    props: {
      paymentData: {
        type: Object,
        required: true
      },
      htmlTac: {
        type: String,
        default: ''
      }
    },
    mounted () {
      document.addEventListener('keyup', this.keyListener)
    },
    beforeDestroy () {
      document.removeEventListener('keyup', this.keyListener)
    },
    data () {
      return {
        agreeTAC: false,
        isSavingData: false,
        keyListener: (evt) => {
          if (evt.keyCode === 27) {
            this.$emit('close', false)
          }
        }
      }
    },
    methods: {
      updatePaymentMethod () {
        this.isSavingData = true
        paymentUpdateService.updatePaymentInfo(this.paymentData).then((response) => {
          this.isSavingData = false
          this.$emit('close', true)
        }).catch((error) => {
          this.isSavingData = false
          if (error.response !== undefined && error.response.data.errorMessage !== undefined) {
            this.$toasted.show('<p>' + error.response.data.errorMessage + '</p>', {
              position: 'bottom-center',
              duration: 10000
            })
          } else {
            this.$toasted.show('<p>Your payment info was not updated. ' +
              'Please try again. If you are having trouble with this process please call Member Services at 1-800-432-6348</p>', {
                position: 'bottom-center',
                duration: 10000
              })
          }
        })
      }
    }
  }
</script>
<style lang="scss">
  @import '~CommonBilling/css/variables';

  .saving-icon {
    font-size: 19px;
  }

.check-label {
  .el-checkbox__label {
    font-size: 14px;
    padding-left: 20px;
    white-space: normal;
    display: inline-table;
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/UpdatePaymentMethods/MSOModal.vue